(function () {
   'use strict';

   angular
      .module('com.vmware.vsphere.client.vm')
      .controller('VmProvisioningNetworkPageController', VmProvisioningNetworkPageController);

   VmProvisioningNetworkPageController.$inject = [
      '$scope',
      '$q',
      'defaultUriSchemeUtil',
      'dataService',
      'vmProvisioningNetworkPageUtilService'
   ];

   function VmProvisioningNetworkPageController(
         $scope,
         $q,
         defaultUriSchemeUtil,
         dataService,
         vmProvisioningNetworkPageUtilService
   ) {
      const self = this;

      init();

      function init() {
         const model = $scope.networkPageModel;

         self.networkMappingParams = model.getNetworkMappingParams();
         self.ipAllocationParams = model.getIpAllocationParams();
         self.initialized = false;

         model.setIsLoading(true);

         vmProvisioningNetworkPageUtilService.getOrRequestNetworkProviderId(model)
            .then(function (result) {
               // Success ... proceed as planned
               self.networkProviderId = result;

               self.initialized = true;
               model.setIsLoading(false);
            }, function (error) {
               self.initialized = true;
               model.setIsLoading(false);

               // Re-throw in expectation that our generic handler will catch this and
               // show info to the user (and also someday hopefully log to the server)
               throw error;
            });
      }
   }
})();